export const convertDateAndTimeToLocaleHandler=(date:string)=>{
  if(!date){
    return '';
  }

  return date.split("T")[1].split(":").slice(0, 2).join(":")
}